var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressCircleBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 114,
    viewBox: "0 0 146 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6592 3.65637L52.9185 10.1537",
    stroke: "#D9D9D9",
    strokeWidth: 1.17974,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9639 1V6.89868",
    stroke: "#D9D9D9",
    strokeWidth: 1.17974,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9689 3.94928L93.0195 9.25809",
    stroke: "#D9D9D9",
    strokeWidth: 1.17974,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.434 13.9771L111.895 18.696",
    stroke: "#D9D9D9",
    strokeWidth: 1.17974,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.361 29.9036L126.052 34.0326",
    stroke: "#D9D9D9",
    strokeWidth: 1.17974,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.978 49.3691L136.08 52.3185",
    stroke: "#D9D9D9",
    strokeWidth: 1.17974,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.927 71.7842H139.029",
    stroke: "#D9D9D9",
    strokeWidth: 1.17974,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M140.799 93.6093L135.49 91.8397",
    stroke: "#D9D9D9",
    strokeWidth: 1.17974,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.541 113.075C132.069 113.075 128.805 110.322 127.232 108.946",
    stroke: "#D9D9D9",
    strokeWidth: 1.17974,
    strokeLinecap: "square"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3872 112.485L18.696 109.536",
    stroke: "#D9D9D9",
    strokeWidth: 1.17974,
    strokeLinecap: "square"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35938 93.6092L9.84792 91.2498",
    stroke: "#D9D9D9",
    strokeWidth: 1.17974,
    strokeLinecap: "square"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1 71.7842H7.48855",
    stroke: "#D9D9D9",
    strokeWidth: 1.17974,
    strokeLinecap: "square"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94971 49.9591L11.0281 51.1388",
    stroke: "#D9D9D9",
    strokeWidth: 1.17974,
    strokeLinecap: "square"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5669 29.9036L19.8757 34.0326",
    stroke: "#D9D9D9",
    strokeWidth: 1.17974,
    strokeLinecap: "square"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4932 13.9771L34.6222 19.2859",
    stroke: "#D9D9D9",
    strokeWidth: 1.17974,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressCircleBars);
export default __webpack_public_path__ + "static/media/progress-circle-bars.4fbe2c1c028966d93d4d09ac79a1c370.svg";
export { ForwardRef as ReactComponent };